import FastMarquee from "react-fast-marquee";

const WORDS = [
  "Accumulation",
  "Growth",
  "Tax-Smart Distribution",
  "Generational Transfer",
  "Fiduciary",
  "Goal-Aligned",
];

const Marquee = () => {
  return (
    <section className="relative bg-[#FAFAF8] border-y border-[#E2E8F0] py-8 lg:py-10 overflow-hidden" data-testid="marquee-section">
      <FastMarquee speed={40} gradient={false} pauseOnHover>
        {WORDS.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-word text-[#0F1E3D] text-4xl lg:text-6xl px-10 tracking-tight">
              {word}
            </span>
            <span className="text-[#C89933] text-3xl lg:text-4xl">&#10022;</span>
          </div>
        ))}
      </FastMarquee>
    </section>
  );
};

export default Marquee;
